module.exports = {
	hooks: {
		attach: function($element, options){
			// console.log('stats attached');
		}
	}
}